<template>
  <!-- 原型 HTML 还原正文；顶/底由门户 PortalNavbar + PortalFooter 提供 -->
  <div class="sol-sb-travel">
    <section class="hero" id="hero">
      <div class="container">
        <div class="hero-grid">
          <div class="hero-content reveal active">
            <div class="hero-badge">
              <span class="dot"></span>
              <span>已服务 800+ 旅游企业 · 覆盖全产业链</span>
            </div>
            <h1>旅游行业解决方案<br><span class="highlight">资源一站整合</span>，全渠道智慧经营</h1>
            <p class="hero-sub">整合旅游资源管理、多渠道分销、会员运营、订单履约、财务结算全链路，为旅游企业提供一体化SaaS数字化管理平台，实现旅游业务全流程智能化运营。</p>
            <div class="hero-tags">
              <span>资源管理</span>
              <span>全渠道分销</span>
              <span>智能履约</span>
              <span>会员运营</span>
              <span>财务结算</span>
            </div>
            <div class="hero-cta">
              <button class="btn btn-primary btn-lg" @click="scrollToSection('cta')"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>立即预约演示</button>
            </div>
            <div class="hero-trust">
              <div class="hero-trust-item"><div><div class="hero-trust-num">800+</div><div class="hero-trust-label">服务旅游企业</div></div></div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item"><div><div class="hero-trust-num">99.9%</div><div class="hero-trust-label">系统可用性</div></div></div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item"><div><div class="hero-trust-num">7×24</div><div class="hero-trust-label">专属服务支持</div></div></div>
            </div>
          </div>
          <div class="hero-visual reveal reveal-delay-1 active">
            <div class="dash-mock">
              <div class="dash-bar">
                <div class="dots"><span></span><span></span><span></span></div>
                <div class="url">app.travelcloud.com/dashboard</div>
              </div>
              <div class="dash-body">
                <div class="dash-side">
                  <div class="icon-item active"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z"/><path d="M3 9h18M9 21V9"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></div>
                </div>
                <div class="dash-main">
                  <div class="dash-stats">
                    <div class="dash-stat">
                      <div class="dash-stat-label">今日订单</div>
                      <div class="dash-stat-val">1,528</div>
                      <div class="dash-stat-trend up">↑ 32.1%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">核销率</div>
                      <div class="dash-stat-val">96.8%</div>
                      <div class="dash-stat-trend up">↑ 8.5%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">渠道覆盖</div>
                      <div class="dash-stat-val">12</div>
                      <div class="dash-stat-trend up">↑ 4个</div>
                    </div>
                  </div>
                  <div class="dash-chart">
                    <div class="dash-chart-head">
                      <div class="dash-chart-title">全渠道销售趋势</div>
                      <div class="dash-chart-tag">近7日</div>
                    </div>
                    <div class="bars">
                      <div class="bar" style="height:52%"></div>
                      <div class="bar" style="height:68%"></div>
                      <div class="bar dim" style="height:35%"></div>
                      <div class="bar" style="height:82%"></div>
                      <div class="bar" style="height:60%"></div>
                      <div class="bar" style="height:90%"></div>
                      <div class="bar" style="height:95%"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dash-float dash-float-1">
              <div class="dash-float-icon green">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">库存秒级同步</div>
                <div class="label">全渠道 · 不超卖</div>
              </div>
            </div>
            <div class="dash-float dash-float-2">
              <div class="dash-float-icon blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">履约效率 ↑70%</div>
                <div class="label">智能履约引擎</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section pain-section" id="pain">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">01 PAIN POINTS</div>
          <h2 class="section-title">行业现状与经营痛点</h2>
          <p class="section-subtitle">传统旅游经营模式存在资源整合难、渠道管理乱、客户运营弱等诸多难题，严重制约旅游企业规模化发展</p>
        </div>
        <div class="pain-grid">
          <div class="pain-card reveal">
            <div class="pain-num">01</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 12a9 9 0 11-6.219-8.56"/><path d="M22 4L12 14.01l-3-3"/></svg>
            </div>
            <h3 class="pain-title">资源整合困难</h3>
            <p class="pain-desc">酒店、门票、交通、导游等旅游资源分散在不同供应商，产品打包组合效率低，难以快速响应市场需求。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">02</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
            </div>
            <h3 class="pain-title">渠道管理混乱</h3>
            <p class="pain-desc">OTA平台、自营官网、小程序等多渠道价格、库存难以统一管理，超卖、价格冲突问题频发。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">03</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3 class="pain-title">客户运营薄弱</h3>
            <p class="pain-desc">游客数据分散在各渠道，缺乏统一会员体系，无法精准营销与个性化推荐，复购率低。</p>
          </div>
          <div class="pain-card reveal">
            <div class="pain-num">04</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
            </div>
            <h3 class="pain-title">订单履约复杂</h3>
            <p class="pain-desc">旅游产品涉及多环节履约（预订、出票、核销、退款），流程繁琐易出错，人工处理效率低。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">05</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3 class="pain-title">财务管理低效</h3>
            <p class="pain-desc">供应商结算、分销佣金、渠道对账核算依赖手工，费时费力且极易出现误差。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">06</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <h3 class="pain-title">缺乏数据洞察</h3>
            <p class="pain-desc">游客偏好、线路热度、渠道转化等经营数据不透明，产品设计与营销策略全凭经验。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-section" id="solution">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">02 SOLUTION OVERVIEW</div>
          <h2 class="section-title">解决方案总览</h2>
          <p class="section-subtitle">专为旅游企业打造的一体化SaaS数字化管理平台，全方位解决旅游行业经营痛点</p>
        </div>
        <div class="solution-grid">
          <div class="solution-card reveal">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>
            </div>
            <h3>方案简介</h3>
            <p>整合旅游资源管理、多渠道分销、会员运营、订单履约、财务结算全链路，为旅游企业提供一体化SaaS数字化管理平台，实现旅游业务全流程智能化运营。</p>
          </div>
          <div class="solution-card reveal reveal-delay-1">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/><path d="M2 12h20"/></svg>
            </div>
            <h3>方案目标</h3>
            <p>实现旅游资源一站整合、全渠道统一分销、客户精细化运营、财务自动化结算，助力旅游企业降本增效、提升客户满意度与复购率。</p>
          </div>
          <div class="solution-card reveal reveal-delay-2">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3>适用对象</h3>
            <p>旅行社、在线旅游平台、景区运营公司、酒店集团、旅游批发商、定制游服务商。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section func-section" id="features">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">03 CORE MODULES</div>
          <h2 class="section-title">核心功能模块</h2>
          <p class="section-subtitle">全链路数字化功能矩阵，覆盖旅游经营全场景，一站式解决经营管理难题</p>
        </div>
        <div class="func-grid">
          <div class="func-card reveal">
            <div class="func-card-num">01</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
              </div>
              <h3>旅游资源管理中心</h3>
              <p>统一管理酒店、门票、线路、交通、导游等旅游资源，支持打包组合、动态定价、库存日历管理。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">02</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
              </div>
              <h3>全渠道分销引擎</h3>
              <p>一键分发至OTA平台、自营小程序/H5商城、微信公众号、同业分销渠道，全渠道库存实时同步，杜绝超卖。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">03</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 10h20"/></svg>
              </div>
              <h3>智能订单履约系统</h3>
              <p>覆盖预订、支付、出票、核销、退款全流程，支持多供应商订单自动拆分与路由，大幅提升履约效率。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">04</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
              </div>
              <h3>会员私域运营平台</h3>
              <p>统一线上线下会员档案，支持会员分级、积分权益、优惠券、储值卡，结合标签精准触达，深度激活客户资产。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">05</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
              </div>
              <h3>供应商协同管理</h3>
              <p>供应商在线入驻、产品发布、订单处理、结算对账一体化协同，降低沟通成本，提升合作效率。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">06</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/></svg>
              </div>
              <h3>财务智能结算中心</h3>
              <p>自动归集全渠道收入、计算供应商分账与分销佣金，自动生成财务报表与对账单，杜绝核算误差。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">07</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <h3>全域营销工具矩阵</h3>
              <p>拼团、秒杀、早鸟价、分销裂变、优惠券等旅游营销玩法，适配淡季促销、新线推广等场景。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">08</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
              </div>
              <h3>数据智能决策看板</h3>
              <p>实时监控订单量、核销率、渠道转化、客户复购等核心指标，可视化图表辅助科学决策。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section advantage-section" id="advantage">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">04 CORE ADVANTAGES</div>
          <h2 class="section-title">方案核心优势</h2>
          <p class="section-subtitle">区别于单一功能旅游系统，依托一体化SaaS平台优势，为企业提供全链路数字化解决方案</p>
        </div>
        <div class="advantage-grid">
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3>资源一站整合</h3>
            <p>接入海量旅游资源库，支持自有资源+第三方资源灵活组合，产品上线效率提升5倍以上。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </div>
            <h3>全渠道价格库存同步</h3>
            <p>秒级同步全渠道库存与价格，毫秒级响应订单变更，彻底告别超卖与价格冲突。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/></svg>
            </div>
            <h3>智能履约引擎</h3>
            <p>自动化订单拆分、路由、核销，履约准确率99.9%，人工介入率降低80%。</p>
          </div>
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>
            </div>
            <h3>轻量化SaaS部署</h3>
            <p>无需技术团队、无需服务器部署，开通即用，按需订阅，中小企业零门槛数字化转型。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
            </div>
            <h3>生态深度对接</h3>
            <p>对接主流OTA平台、支付渠道、电子发票、保险服务商，构建完整旅游服务生态。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg>
            </div>
            <h3>灵活可配置</h3>
            <p>支持按企业需求定制产品模板、定价策略、权限体系，适配旅行社、景区、酒店等不同业态。</p>
          </div>
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </div>
            <h3>多终端适配</h3>
            <p>电脑端管理后台、导游/司机端APP、游客小程序/H5，全场景覆盖，数据实时同步。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <h3>专属运营支持</h3>
            <p>提供行业运营顾问一对一服务，从上线配置、运营策略到数据分析全程陪跑。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section scenario-section" id="scenario">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">05 USE CASES</div>
          <h2 class="section-title">典型应用场景</h2>
          <p class="section-subtitle">贴合旅游行业全场景经营需求，全方位适配企业日常运营与拓客增收场景</p>
        </div>
        <div class="scenario-grid">
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 01</div>
            <h3>跟团游线路运营</h3>
            <p>快速打包机酒门票线路产品，多渠道统一发布，订单自动分配导游与车辆，全程数字化管理。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 02</div>
            <h3>景区门票分销</h3>
            <p>景区门票一键分发至美团、携程、飞猪等OTA平台，库存实时同步，扫码核销便捷高效。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 03</div>
            <h3>民宿/酒店直销</h3>
            <p>搭建自有小程序酒店预订平台，会员专属折扣、连住优惠，沉淀私域客户资产。</p>
          </div>
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 04</div>
            <h3>定制游服务管理</h3>
            <p>支持行程定制、报价生成、资源锁定、客户确认一站式管理，提升定制游服务效率。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 05</div>
            <h3>企业团建/会奖旅游</h3>
            <p>支持企业客户批量预订、定制行程、统一结算、电子发票开具，标准化商务服务流程。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 06</div>
            <h3>同业分销合作</h3>
            <p>搭建同业分销平台，快速拓展分销网络，自动计算佣金与返利，实现规模化增长。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section value-section" id="value">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">06 CUSTOMER VALUE</div>
          <h2 class="section-title">客户落地价值</h2>
          <p class="section-subtitle">量化数字化转型成果，实实在在为旅游企业降本、增效、增收</p>
        </div>
        <div class="value-grid">
          <div class="value-card reveal">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <h3>运营效率大幅提升</h3>
            <p>自动化替代人工操作，订单处理效率提升70%，人力成本降低40%以上。</p>
            <div class="value-highlight">运营成本 ↓40%</div>
          </div>
          <div class="value-card reveal reveal-delay-1">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
            </div>
            <h3>渠道收入显著增长</h3>
            <p>全渠道分销引擎助力产品覆盖扩大3倍以上，渠道销售收入增长30%-50%。</p>
            <div class="value-highlight">营收 ↑30%-50%</div>
          </div>
          <div class="value-card reveal reveal-delay-2">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            </div>
            <h3>客户复购有效提升</h3>
            <p>精细化会员运营，精准触达营销，客户复购率提升25%，会员活跃度翻倍。</p>
            <div class="value-highlight">复购率 ↑25%</div>
          </div>
          <div class="value-card reveal reveal-delay-3">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>
            </div>
            <h3>经营决策科学化</h3>
            <p>全维度数据分析驱动产品设计、定价策略与渠道优化，决策效率提升60%。</p>
            <div class="value-highlight">决策效率 60%↑</div>
          </div>
        </div>
      </div>
    </section>

    <section class="trust-section" id="trust">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">07 TRUST & RECOGNITION</div>
          <h2 class="section-title">品牌信任背书</h2>
          <p class="section-subtitle">800+ 旅游企业的共同选择，权威认证护航，生态合作共建数字化未来</p>
        </div>
        <div class="trust-stats reveal">
          <div class="trust-stat">
            <div class="num">800<span class="unit">+</span></div>
            <div class="label">服务旅游企业</div>
          </div>
          <div class="trust-stat">
            <div class="num">12<span class="unit">+</span></div>
            <div class="label">对接OTA渠道</div>
          </div>
          <div class="trust-stat">
            <div class="num">99.9<span class="unit">%</span></div>
            <div class="label">系统可用性</div>
          </div>
          <div class="trust-stat">
            <div class="num">7×24</div>
            <div class="label">专属服务</div>
          </div>
        </div>
        <div class="logo-wall reveal">
          <div class="logo-wall-title">TRUSTED BY LEADING BRANDS</div>
          <div class="logo-grid">
            <div class="logo-item">携程旅行</div>
            <div class="logo-item">同程旅游</div>
            <div class="logo-item">途牛旅游</div>
            <div class="logo-item">马蜂窝</div>
            <div class="logo-item">飞猪旅行</div>
            <div class="logo-item">春秋旅游</div>
            <div class="logo-item">众信旅游</div>
            <div class="logo-item">凯撒旅游</div>
            <div class="logo-item">广之旅</div>
            <div class="logo-item">中青旅</div>
            <div class="logo-item">锦江旅游</div>
            <div class="logo-item">国旅集团</div>
          </div>
        </div>
        <div class="trust-cert reveal">
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">ISO 27001 信息安全认证</div>
              <div class="desc">国际权威信息安全管理体系认证</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12l2 2 4-4"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">等保三级认证</div>
              <div class="desc">国家信息安全等级保护三级资质</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">高新技术企业</div>
              <div class="desc">国家级高新技术企业资质认证</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section faq-section" id="faq">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">08 FAQ</div>
          <h2 class="section-title">常见问题</h2>
          <p class="section-subtitle">解答用户高频疑问，打消合作顾虑</p>
        </div>
        <div class="faq-wrap reveal">
          <div class="faq-item">
            <div class="faq-q">
              <span>支持对接哪些OTA平台？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">系统提供标准化接口，已对接携程、飞猪、美团、马蜂窝等主流OTA平台，同时支持自定义API对接其他渠道。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>库存同步速度如何？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">采用毫秒级库存同步机制，订单产生瞬间全渠道库存更新，确保多平台同时售卖不超卖。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>支持电子合同和电子发票吗？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">内置电子合同签约和电子发票开具功能，对接主流电子发票平台，满足合规要求。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>系统培训和技术支持怎么样？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">提供完整的操作培训、使用教程，7×24小时技术支持，一对一专属客服服务。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>收费模式是怎样的？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">按需订阅付费，根据业务规模和功能需求灵活选择套餐，支持按年付费，无隐藏费用。</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section" id="cta">
      <div class="container">
        <div class="cta-inner reveal">
          <h2>助力旅游企业<span class="highlight">数字化转型升级</span></h2>
          <p>全域一体化智慧经营，降本增效、全域增收，开启旅游数字化新征程</p>
          <div class="cta-options">
              <a class="btn btn-primary btn-lg" href="#" role="button" @click.prevent="openCustomerService">咨询详情</a>
            </div>
          <div class="cta-note">
            <span>7×24小时技术支持</span>
            <span class="dot"></span>
            <span>一对一专属服务</span>
            <span class="dot"></span>
            <span>免费落地培训指导</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { openCustomerService } from '../../openCustomerService'
defineOptions({ name: 'PortalSbTravel' })

let revealIo: IntersectionObserver | null = null

function scrollToSection(id: string) {
  const el = document.getElementById(id)
  if (!el) return
  const scroller = document.querySelector('.portal-page') as HTMLElement | null
  if (scroller) {
    const top =
      el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12
    scroller.scrollTo({ top, behavior: 'smooth' })
    return
  }
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' })
}

function bindFaq() {
  const rootEl = document.querySelector('.sol-sb-travel')
  if (!rootEl) return
  rootEl.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q') as HTMLElement | null
    const a = item.querySelector('.faq-a') as HTMLElement | null
    if (!q || !a) return
    a.style.maxHeight = '0'
    q.onclick = () => {
      const isActive = item.classList.contains('active')
      rootEl.querySelectorAll('.faq-item').forEach((other) => {
        other.classList.remove('active')
        const oa = other.querySelector('.faq-a') as HTMLElement | null
        if (oa) oa.style.maxHeight = '0'
      })
      if (!isActive) {
        item.classList.add('active')
        a.style.maxHeight = a.scrollHeight + 'px'
      }
    }
  })
}

function bindReveal() {
  const nodes = document.querySelectorAll('.sol-sb-travel .reveal')
  revealIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('active')
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  )
  nodes.forEach((n) => revealIo!.observe(n))
}

function bindBars() {
  const bars = document.querySelectorAll('.sol-sb-travel .bars .bar')
  bars.forEach((bar, i) => {
    const el = bar as HTMLElement
    const h = el.style.height
    if (!h) return
    el.style.height = '0'
    window.setTimeout(() => {
      el.style.transition = `height .8s ease ${i * 0.08}s`
      el.style.height = h
    }, 100)
  })
}

onMounted(() => {
  bindFaq()
  bindReveal()
  bindBars()
})

onBeforeUnmount(() => {
  revealIo?.disconnect()
  revealIo = null
})
</script>

<style lang="scss">

.sol-sb-travel,.sol-sb-travel *,.sol-sb-travel *::before,.sol-sb-travel *::after{margin:0;padding:0;box-sizing:border-box}
.sol-sb-travel{--c-primary:#1e88e5;--c-primary-2:#1976d2;--c-primary-3:#1565c0;--c-primary-4:#0d47a1;--c-primary-light:#42a5f5;--c-primary-bright:#2196f3;--c-cyan:#06b6d4;--c-slate:#475569;--c-slate-light:#64748b;--c-text:#0f172a;--c-text-mid:#334155;--c-bg:#f5f9ff;--c-bg-2:#eef4fc;--c-bg-3:#e8f1fb;--c-border:#e2e8f0;--c-white:#fff;--c-footer:#0a1929;--c-footer-2:#0d2238;--radius:14px;--radius-lg:22px;--shadow-sm:0 2px 8px rgba(30,136,229,.08);--shadow:0 8px 28px rgba(30,136,229,.10);--shadow-lg:0 18px 56px rgba(30,136,229,.14);--shadow-xl:0 28px 80px rgba(30,136,229,.18);--shadow-blue:0 10px 30px rgba(30,136,229,.35);--max-w:1280px;--font:-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif}
.sol-sb-travel{scroll-behavior:smooth;font-size:16px}
.sol-sb-travel{font-family:var(--font);color:var(--c-text);background:var(--c-white);line-height:1.7;overflow-x:hidden;-webkit-font-smoothing:antialiased}
.sol-sb-travel a{text-decoration:none;color:inherit}.sol-sb-travel img{max-width:100%;display:block}.sol-sb-travel ul{list-style:none}
.sol-sb-travel .container{max-width:var(--max-w);margin:0 auto;padding:0 24px}
.sol-sb-travel .section{padding:110px 0;position:relative}.section-sm{padding:72px 0}
.sol-sb-travel .eyebrow{font-size:.8rem;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--c-primary);margin-bottom:12px}
.sol-sb-travel .section-num{font-size:.82rem;font-weight:800;letter-spacing:.18em;color:var(--c-primary);display:inline-block;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:6px 14px;border-radius:100px;margin-bottom:14px}
.sol-sb-travel .section-title{font-size:2.4rem;font-weight:800;color:var(--c-text);line-height:1.25;margin-bottom:18px;letter-spacing:-.02em}
.sol-sb-travel .section-subtitle{font-size:1.08rem;color:var(--c-slate);max-width:720px;line-height:1.8}
.sol-sb-travel .section-head{margin-bottom:64px}.section-head.center{text-align:center}.section-head.center .section-subtitle{margin:0 auto}.section-head.center .section-num{display:inline-block}
.sol-sb-travel .header{position:fixed;top:0;left:0;right:0;z-index:1000;background:rgba(255,255,255,.97);backdrop-filter:blur(16px);border-bottom:1px solid var(--c-border);transition:box-shadow .3s}
.sol-sb-travel .header.scrolled{box-shadow:0 4px 20px rgba(30,136,229,.08)}
.sol-sb-travel .header-inner{display:flex;align-items:center;justify-content:space-between;height:72px;max-width:var(--max-w);margin:0 auto;padding:0 24px}
.sol-sb-travel .logo{display:flex;align-items:center;gap:12px;font-size:1.3rem;font-weight:800;color:var(--c-primary-3);letter-spacing:-.02em}
.sol-sb-travel .logo svg{width:36px;height:36px;flex-shrink:0}
.sol-sb-travel .nav{display:flex;align-items:center;gap:36px}.nav a{font-size:.94rem;color:var(--c-text-mid);font-weight:500;transition:color .2s;position:relative}.nav a:hover{color:var(--c-primary)}
.sol-sb-travel .nav a::after{content:"";position:absolute;bottom:-6px;left:0;width:0;height:2.5px;background:var(--c-primary);border-radius:2px;transition:width .25s}.nav a:hover::after{width:100%}
.sol-sb-travel .header-cta{display:flex;align-items:center;gap:14px}
.sol-sb-travel .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 28px;border-radius:12px;font-size:.94rem;font-weight:600;cursor:pointer;border:none;transition:all .25s;white-space:nowrap;line-height:1.2}
.sol-sb-travel .btn-primary{background:linear-gradient(180deg,#42a5f5 0%,#1e88e5 50%,#1976d2 100%);color:#fff;box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 4px 0 var(--c-primary-3),0 8px 20px rgba(30,136,229,.35)}
.sol-sb-travel .btn-primary:hover{transform:translateY(-2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 6px 0 var(--c-primary-3),0 12px 26px rgba(30,136,229,.45)}
.sol-sb-travel .btn-primary:active{transform:translateY(2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 1px 0 var(--c-primary-3),0 4px 12px rgba(30,136,229,.35)}
.sol-sb-travel .btn-outline{background:#fff;color:var(--c-primary-3);border:1.5px solid var(--c-border);box-shadow:0 4px 12px rgba(30,136,229,.08)}
.sol-sb-travel .btn-outline:hover{border-color:var(--c-primary);color:var(--c-primary);box-shadow:0 6px 18px rgba(30,136,229,.18);transform:translateY(-2px)}
.sol-sb-travel .btn-ghost{background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.35);backdrop-filter:blur(6px)}
.sol-sb-travel .btn-ghost:hover{background:rgba(255,255,255,.24);transform:translateY(-2px)}
.sol-sb-travel .btn-lg{padding:17px 40px;font-size:1.05rem;border-radius:14px}
.sol-sb-travel .btn-lg.btn-primary{box-shadow:inset 0 1px 0 rgba(255,255,255,.45),inset 0 -2px 0 rgba(0,0,0,.1),0 6px 0 var(--c-primary-3),0 12px 28px rgba(30,136,229,.4)}
.sol-sb-travel .btn-sm{padding:9px 20px;font-size:.85rem;border-radius:10px}
.sol-sb-travel .menu-toggle{display:none;flex-direction:column;gap:5px;cursor:pointer;padding:6px;background:none;border:none}
.sol-sb-travel .menu-toggle span{width:24px;height:2.5px;background:var(--c-primary-3);border-radius:2px;transition:.3s}
.sol-sb-travel .menu-toggle.active span:nth-child(1){transform:translateY(7.5px) rotate(45deg)}.menu-toggle.active span:nth-child(2){opacity:0}.menu-toggle.active span:nth-child(3){transform:translateY(-7.5px) rotate(-45deg)}
.sol-sb-travel .hero{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 30%,#1e88e5 70%,#2196f3 100%);padding:150px 0 100px;overflow:hidden}
.sol-sb-travel .hero::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 15% 40%,rgba(255,255,255,.18) 0%,transparent 45%),radial-gradient(circle at 85% 25%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 70% 80%,rgba(255,255,255,.1) 0%,transparent 40%);pointer-events:none}
.sol-sb-travel .hero::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:80px;background:linear-gradient(to bottom,transparent,var(--c-white));pointer-events:none}
.sol-sb-travel .hero-grid{display:grid;grid-template-columns:1.1fr .9fr;gap:56px;align-items:center;position:relative;z-index:1}
.sol-sb-travel .hero-badge{display:inline-flex;align-items:center;gap:10px;padding:8px 18px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.25);border-radius:100px;color:#fff;font-size:.82rem;font-weight:500;margin-bottom:30px;backdrop-filter:blur(8px)}
.sol-sb-travel .hero-badge .dot{width:8px;height:8px;background:#34d399;border-radius:50%;box-shadow:0 0 10px #34d399;animation:pulse 1.6s ease-in-out infinite}
@keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.6;transform:scale(1.3)}}
.sol-sb-travel .hero h1{font-size:3.2rem;font-weight:900;color:#fff;line-height:1.18;letter-spacing:-.025em;margin-bottom:24px}
.sol-sb-travel .hero h1 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;position:relative;display:inline-block}
.sol-sb-travel .hero h1 .highlight::after{content:"";position:absolute;left:0;right:0;bottom:-4px;height:6px;background:linear-gradient(90deg,#fff 0%,rgba(255,255,255,.2) 100%);border-radius:3px;opacity:.5}
.sol-sb-travel .hero-sub{font-size:1.14rem;color:rgba(255,255,255,.85);line-height:1.85;margin-bottom:28px;max-width:560px}
.sol-sb-travel .hero-tags{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:36px}
.sol-sb-travel .hero-tags span{padding:7px 16px;border:1px solid rgba(255,255,255,.3);border-radius:30px;font-size:.8rem;color:rgba(255,255,255,.85);background:rgba(255,255,255,.06);backdrop-filter:blur(4px)}
.sol-sb-travel .hero-cta{display:flex;gap:16px;margin-bottom:40px;flex-wrap:wrap}
.sol-sb-travel .hero-trust{display:flex;align-items:center;gap:30px;flex-wrap:wrap}
.sol-sb-travel .hero-trust-item{display:flex;align-items:center;gap:10px}.hero-trust-num{font-size:1.65rem;font-weight:800;color:#fff}.hero-trust-label{font-size:.82rem;color:rgba(255,255,255,.6)}.hero-trust-divider{width:1px;height:40px;background:rgba(255,255,255,.18)}
.sol-sb-travel .hero-visual{position:relative}
.sol-sb-travel .dash-mock{background:#fff;border-radius:18px;box-shadow:0 40px 90px rgba(0,30,80,.45);overflow:hidden;border:1px solid rgba(255,255,255,.2)}
.sol-sb-travel .dash-bar{display:flex;align-items:center;gap:8px;padding:14px 18px;background:#f0f7ff;border-bottom:1px solid var(--c-border)}
.sol-sb-travel .dash-bar .dots{display:flex;gap:6px}.dash-bar .dots span{width:10px;height:10px;border-radius:50%}.dash-bar .dots span:nth-child(1){background:#ef4444}.dash-bar .dots span:nth-child(2){background:#f59e0b}.dash-bar .dots span:nth-child(3){background:#22c55e}
.sol-sb-travel .dash-bar .url{flex:1;text-align:center;font-size:.72rem;color:var(--c-slate-light);background:#fff;border:1px solid var(--c-border);border-radius:6px;padding:4px 14px;margin-left:8px}
.sol-sb-travel .dash-body{display:grid;grid-template-columns:68px 1fr;min-height:360px}
.sol-sb-travel .dash-side{background:linear-gradient(180deg,#0d47a1,#1565c0);padding:16px 0;display:flex;flex-direction:column;align-items:center;gap:16px}
.sol-sb-travel .dash-side .icon-item{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.5);transition:.2s}
.sol-sb-travel .dash-side .icon-item.active{background:linear-gradient(135deg,#42a5f5,#1e88e5);color:#fff;box-shadow:0 4px 12px rgba(30,136,229,.5)}
.sol-sb-travel .dash-side .icon-item svg{width:18px;height:18px}
.sol-sb-travel .dash-main{padding:20px;background:#fafbfc}
.sol-sb-travel .dash-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px}
.sol-sb-travel .dash-stat{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:14px;transition:.2s}.dash-stat:hover{border-color:var(--c-primary-light);box-shadow:0 4px 12px rgba(30,136,229,.1)}
.sol-sb-travel .dash-stat-label{font-size:.68rem;color:var(--c-slate-light);margin-bottom:4px}.dash-stat-val{font-size:1.2rem;font-weight:800;color:var(--c-text)}.dash-stat-trend{font-size:.65rem;font-weight:700;margin-top:3px}
.sol-sb-travel .up{color:#10b981}
.sol-sb-travel .dash-chart{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:16px}
.sol-sb-travel .dash-chart-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
.sol-sb-travel .dash-chart-title{font-size:.74rem;font-weight:600;color:var(--c-text)}.dash-chart-tag{font-size:.62rem;color:var(--c-primary);background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:3px 10px;border-radius:100px;font-weight:600}
.sol-sb-travel .bars{display:flex;align-items:flex-end;gap:6px;height:96px}.bar{flex:1;border-radius:4px 4px 0 0;background:linear-gradient(180deg,#42a5f5,#1565c0);opacity:.9;transition:opacity .2s}.bar:hover{opacity:1}.bar.dim{background:linear-gradient(180deg,#cbd5e1,#94a3b8)}
.sol-sb-travel .dash-float{position:absolute;background:#fff;border-radius:14px;box-shadow:0 14px 36px rgba(0,30,80,.25);padding:14px 18px;display:flex;align-items:center;gap:14px;animation:float 3.5s ease-in-out infinite;border:1px solid rgba(255,255,255,.6)}
.sol-sb-travel .dash-float-1{top:-20px;right:-12px;animation-delay:0s}.dash-float-2{bottom:-18px;left:-18px;animation-delay:1.5s}
.sol-sb-travel .dash-float-icon{width:42px;height:42px;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.sol-sb-travel .dash-float-icon.green{background:linear-gradient(135deg,#d1fae5,#a7f3d0);color:#10b981}.dash-float-icon.blue{background:linear-gradient(135deg,#dbeafe,#bfdbfe);color:#1e88e5}
.sol-sb-travel .dash-float-text .num{font-size:1.05rem;font-weight:800;color:var(--c-text)}.dash-float-text .label{font-size:.7rem;color:var(--c-slate-light)}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
.sol-sb-travel .pain-section{background:linear-gradient(180deg,var(--c-white),var(--c-bg))}.pain-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-sb-travel .pain-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 30px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-travel .pain-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-xl);transform:translateY(-6px)}.pain-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:left;transition:transform .4s}.pain-card:hover::before{transform:scaleX(1)}
.sol-sb-travel .pain-num{position:absolute;top:24px;right:28px;font-size:2.8rem;font-weight:900;color:rgba(30,136,229,.06);line-height:1}
.sol-sb-travel .pain-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.15)}.pain-icon svg{width:28px;height:28px;color:var(--c-primary-2)}
.sol-sb-travel .pain-title{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:12px}.pain-desc{font-size:.92rem;color:var(--c-slate);line-height:1.8}
.sol-sb-travel .solution-section{background:#fff}.solution-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-sb-travel .solution-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:40px 32px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-travel .solution-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px)}.solution-card::after{content:"";position:absolute;top:-30px;right:-30px;width:120px;height:120px;background:radial-gradient(circle,rgba(30,136,229,.1),transparent);pointer-events:none}
.sol-sb-travel .solution-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.3)}.solution-icon svg{width:26px;height:26px;color:#fff}
.sol-sb-travel .solution-card h3{font-size:1.25rem;font-weight:700;color:var(--c-text);margin-bottom:14px}.solution-card p{font-size:.95rem;color:var(--c-slate);line-height:1.8}
.sol-sb-travel .func-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}.func-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px}
.sol-sb-travel .func-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 32px;transition:all .3s;position:relative;overflow:hidden;display:flex;gap:24px}
.sol-sb-travel .func-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-lg);transform:translateY(-4px)}.func-card::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px;background:linear-gradient(180deg,#1e88e5,#42a5f5);transform:scaleY(0);transform-origin:top;transition:transform .4s}.func-card:hover::before{transform:scaleY(1)}
.sol-sb-travel .func-card-num{font-size:2.4rem;font-weight:900;color:rgba(30,136,229,.12);line-height:1;flex-shrink:0;min-width:56px}
.sol-sb-travel .func-card-body{flex:1}.func-card-icon{width:44px;height:44px;border-radius:11px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:16px;box-shadow:0 4px 12px rgba(30,136,229,.12)}.func-card-icon svg{width:22px;height:22px;color:var(--c-primary-2)}
.sol-sb-travel .func-card-body h3{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:10px}.func-card-body p{font-size:.92rem;color:var(--c-slate);line-height:1.8}
.sol-sb-travel .advantage-section{background:#fff}.advantage-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-sb-travel .advantage-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:34px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-travel .advantage-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}.advantage-card::before{content:"";position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#1e88e5,#42a5f5);transform:scaleX(0);transform-origin:left;transition:transform .4s}.advantage-card:hover::before{transform:scaleX(1)}
.sol-sb-travel .advantage-icon{width:48px;height:48px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:20px;box-shadow:0 6px 16px rgba(30,136,229,.25)}.advantage-icon svg{width:24px;height:24px;color:#fff}
.sol-sb-travel .advantage-card h3{font-size:1.12rem;font-weight:700;color:var(--c-text);margin-bottom:12px}.advantage-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}
.sol-sb-travel .scenario-section{background:linear-gradient(180deg,var(--c-bg),var(--c-bg-2))}.scenario-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-sb-travel .scenario-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:32px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-travel .scenario-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-sb-travel .scenario-tag{display:inline-block;padding:5px 12px;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));color:var(--c-primary);font-size:.72rem;font-weight:700;border-radius:100px;margin-bottom:16px}
.sol-sb-travel .scenario-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}.scenario-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}
.sol-sb-travel .scenario-card::after{content:"";position:absolute;bottom:-20px;right:-20px;width:80px;height:80px;background:radial-gradient(circle,rgba(30,136,229,.06),transparent);pointer-events:none}
.sol-sb-travel .value-section{background:#fff}.value-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px}
.sol-sb-travel .value-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 26px;text-align:center;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-travel .value-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-6px)}.value-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:center;transition:transform .4s}.value-card:hover::before{transform:scaleX(1)}
.sol-sb-travel .value-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin:0 auto 20px;box-shadow:0 8px 20px rgba(30,136,229,.3)}.value-icon svg{width:28px;height:28px;color:#fff}
.sol-sb-travel .value-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}.value-card p{font-size:.88rem;color:var(--c-slate);line-height:1.75}.value-highlight{display:inline-block;margin-top:14px;padding:5px 14px;background:#fff;border:1px solid var(--c-primary-light);border-radius:100px;font-size:.78rem;font-weight:700;color:var(--c-primary)}
.sol-sb-travel .trust-section{background:linear-gradient(135deg,#0a3a7a 0%,#0d47a1 50%,#1565c0 100%);position:relative;overflow:hidden;padding:100px 0}
.sol-sb-travel .trust-section::before{content:"";position:absolute;top:-50%;right:-10%;width:600px;height:600px;background:radial-gradient(circle,rgba(66,165,245,.15) 0%,transparent 70%);pointer-events:none}
.sol-sb-travel .trust-section::after{content:"";position:absolute;bottom:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.1),transparent)}
.sol-sb-travel .trust-section .section-title{color:#fff}.trust-section .section-subtitle{color:rgba(255,255,255,.7)}.trust-section .section-num{color:#90caf9;background:rgba(255,255,255,.1)}
.sol-sb-travel .trust-stats{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;margin-bottom:60px}.trust-stat{text-align:center;padding:36px 22px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);transition:.3s;backdrop-filter:blur(6px)}.trust-stat:hover{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.18);transform:translateY(-6px)}
.sol-sb-travel .trust-stat .num{font-size:2.8rem;font-weight:900;color:#fff;letter-spacing:-.025em;line-height:1;margin-bottom:8px}.trust-stat .num .unit{font-size:1.4rem;font-weight:700}.trust-stat .label{font-size:.88rem;color:rgba(255,255,255,.55);font-weight:500}
.sol-sb-travel .logo-wall{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius-lg);padding:44px;margin-bottom:48px;backdrop-filter:blur(6px)}
.sol-sb-travel .logo-wall-title{text-align:center;font-size:.82rem;color:rgba(255,255,255,.45);letter-spacing:.18em;text-transform:uppercase;margin-bottom:28px;font-weight:600}
.sol-sb-travel .logo-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:18px}.logo-item{height:64px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:.82rem;font-weight:700;color:rgba(255,255,255,.4);transition:.3s}.logo-item:hover{background:rgba(255,255,255,.08);color:rgba(255,255,255,.8);border-color:rgba(255,255,255,.18);transform:translateY(-2px)}
.sol-sb-travel .trust-cert{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}.cert-card{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);padding:28px;display:flex;align-items:center;gap:18px;transition:.3s;backdrop-filter:blur(6px)}.cert-card:hover{background:rgba(255,255,255,.08);transform:translateY(-3px)}
.sol-sb-travel .cert-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,rgba(66,165,245,.2),rgba(30,136,229,.2));display:flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid rgba(66,165,245,.3)}.cert-icon svg{width:26px;height:26px;color:#90caf9}
.sol-sb-travel .cert-info .title{font-size:.92rem;font-weight:700;color:#fff;margin-bottom:4px}.cert-info .desc{font-size:.78rem;color:rgba(255,255,255,.45)}
.sol-sb-travel .faq-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}.faq-wrap{max-width:880px;margin:0 auto}
.sol-sb-travel .faq-item{border:1.5px solid var(--c-border);border-radius:var(--radius);margin-bottom:14px;overflow:hidden;transition:.3s;background:#fff}.faq-item.active{border-color:var(--c-primary);box-shadow:0 8px 28px rgba(30,136,229,.12)}.faq-item.active .faq-q{color:var(--c-primary)}
.sol-sb-travel .faq-q{display:flex;align-items:center;justify-content:space-between;padding:22px 28px;cursor:pointer;font-size:1rem;font-weight:600;color:var(--c-text);transition:color .2s;user-select:none;gap:16px}.faq-q .arrow{width:22px;height:22px;flex-shrink:0;transition:transform .3s;color:var(--c-slate-light)}.faq-item.active .faq-q .arrow{transform:rotate(180deg);color:var(--c-primary)}
.sol-sb-travel .faq-a{max-height:0;overflow:hidden;transition:max-height .4s ease}.faq-a-inner{padding:0 28px 24px;font-size:.94rem;color:var(--c-slate);line-height:1.85}
.sol-sb-travel .cta-section{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 50%,#1e88e5 100%);padding:100px 0;overflow:hidden}
.sol-sb-travel .cta-section::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 70% 30%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 20% 80%,rgba(255,255,255,.12) 0%,transparent 40%);pointer-events:none}
.sol-sb-travel .cta-section::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:60px;background:linear-gradient(to bottom,transparent,var(--c-footer));pointer-events:none}
.sol-sb-travel .cta-inner{position:relative;z-index:1;text-align:center;max-width:820px;margin:0 auto}.cta-inner h2{font-size:2.5rem;font-weight:900;color:#fff;letter-spacing:-.025em;margin-bottom:20px;line-height:1.25}
.sol-sb-travel .cta-inner h2 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}.cta-inner p{font-size:1.12rem;color:rgba(255,255,255,.8);line-height:1.85;margin-bottom:44px}
.sol-sb-travel .cta-options{display:flex;gap:18px;justify-content:center;flex-wrap:wrap;margin-bottom:36px}.cta-note{display:flex;align-items:center;justify-content:center;gap:10px;font-size:.85rem;color:rgba(255,255,255,.5);flex-wrap:wrap}.cta-note .dot{width:5px;height:5px;background:rgba(255,255,255,.3);border-radius:50%}
.sol-sb-travel .reveal{opacity:0;transform:translateY(32px);transition:opacity .8s ease,transform .8s ease}.reveal.active{opacity:1;transform:translateY(0)}.reveal-delay-1{transition-delay:.12s}.reveal-delay-2{transition-delay:.24s}.reveal-delay-3{transition-delay:.36s}
@media(max-width:480px){.container{padding:0 18px}.hero h1{font-size:1.85rem}.section-title{font-size:1.55rem}.dash-stats{grid-template-columns:1fr;gap:8px}.value-grid{grid-template-columns:1fr}}
</style>
